module.exports = __webpack_public_path__ + "static/media/avatar.e516521f.svg";